import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'web-ui-components/lib/molecules/forms';
import { MainFixedFooter } from 'web-ui-components/lib/layout/footers';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Button } from 'web-ui-components/lib/atoms/buttons';

const AccountPoolFooter = ({
  cancelButton,
  cancelbuttonText,
  selectedCount,
  selectAccountText,
  submitAccountPool,
  saveButtonText,
  isLoading,
}) => (
  <div className="web-ui-components" style={{ position: 'fixed', bottom: 0 }}>
    <MainFixedFooter className="u-margin-top-c">
      <Inline.Justified
        nodes={[
          <StandardBody key={'AccountPoolFooter_node_0'}>
            <Button onClick={cancelButton}>{cancelbuttonText}</Button>
          </StandardBody>,
          <StandardBody key={'AccountPoolFooter_node_1'}>
            <Field className="c-m-payee-footer-bar__payee-count">
              <span className="c-m-payee-footer-bar__payee-count-value">
                {selectedCount}
              </span>
              <span className="c-m-payee-footer-bar__payee-count-label">
                {selectAccountText}
              </span>
              <Button
                display="primary"
                isLoading={isLoading}
                onClick={submitAccountPool}
              >
                {saveButtonText}
              </Button>
            </Field>
          </StandardBody>,
        ]}
      />
    </MainFixedFooter>
  </div>
);

AccountPoolFooter.propTypes = {
  cancelbuttonText: PropTypes.string,
  cancelButton: PropTypes.func,
  selectedCount: PropTypes.number,
  saveButtonText: PropTypes.string,
  submitAccountPool: PropTypes.func,
};

export { AccountPoolFooter };
